<template>
    <div>
        <div class="grid pb-0">
            <div class="grid-title d-flex">
                <h4>{{ $t("BOOKING_UNMAP") }}</h4>
                <div class="mr-3">
                    <v-btn outlined @click="exportBooking" class="export-excel">
                        <v-icon size="20" left>
                            save_alt
                        </v-icon>
                        {{ $t("_BOOKING.EXPORT") }}
                    </v-btn>
                </div>
            </div>
            <div class="grid-body border-top-unset list-booking-group">
                <div class="p-3">
                    <div class="search-box">
                        <v-btn @click="searchByCode()" outlined class="search-icon-left">
                        <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path>
                        </svg>
                        </v-btn>
                        <input v-model="bookingCodeSearch" @keyup.enter="searchByCode()"  type="text" :placeholder="$t('_BOOKING.ENTER_BOOKING_CODE_OTA')" />
                        <v-btn outlined @click="openPopup()" class="search-icon-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path></svg>
                        </v-btn>
                    </div>
                    <!-- start -->
                    <div class="overlay-search" @click="openPopup()" v-if="isShowPopup"></div>
                    <div class="popup-search p-3" v-if="isShowPopup">
                        <b-row>
                            <b-col md="6">
                                <label>
                                    {{
                                        $t("_BOOKING.SEARCH_CONDITION")
                                    }}
                                </label>
                                <v-select outlined dense item-text="text" item-value="value"
                                    :items="listSearchCondition" v-model="selectedSearchCondition" class="w-100" />
                            </b-col>
                            <b-col md="6"
                                v-if="selectedSearchCondition === 'BOOKING_CODE' || selectedSearchCondition === 'BOOKING_CODE_OTA'">
                                <label>{{
                                    $t("_BOOKING.SEARCH_BOOKING_CODE")
                                }}</label>
                                <v-text-field v-model="paging.code" dense outlined class="w-100"></v-text-field>
                            </b-col>
                            <b-col md="6" v-if="selectedSearchCondition === null ||
                                selectedSearchCondition === 'BOOKING_DATE' ||
                                selectedSearchCondition === 'CHECKIN_DATE' ||
                                selectedSearchCondition === 'CHECKOUT_DATE'
                                ">
                                <label>{{
                                    $t("_BOOKING.SEARCH_DATE")
                                }}</label>
                                <div class="d-flex justify-content-between">
                                    <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                                    :type="selectedSearchCondition === 'BOOKING_DATE' ? 'datetime' : 'date'"
                                        :popup-class="'popup-calendar-desktop-detailhotel'" v-model="dateRange"
                                        :lang="languageDate" 
                                        :format="selectedSearchCondition === 'BOOKING_DATE' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'" :editable="false" :shortcuts=[]
                                        range placeholder="Select date range">
                                    </date-picker>
                                </div>
                            </b-col>
                            <b-col md="6" v-if="selectedSearchCondition === 'STAY_DATE'">
                                <label>{{
                                $t("_BOOKING.SEARCH_BY.STAYING_DATE")
                                }}</label>
                                <div class="d-flex justify-content-between">
                                <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                                    :popup-class="'popup-calendar-desktop-detailhotel'" v-model="stayDate" :lang="languageDate"
                                    :format="'DD/MM/YYYY'" :editable="false" :shortcuts=[] :range="false" placeholder="Select date">
                                </date-picker>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" class="pt-0 pr-0">
                                <label>{{
                                    $t("BOOKING_CHANNEL")
                                }}</label>
                                <v-autocomplete dense outlined item-text="text" item-value="value"
                                    :items="listSelectOTA" v-model="selectedOTA" chips multiple  ref="selectedOTA">
                                    <template v-slot:prepend-item>
                                        <p class="mx-3 mt-1"> <a class="text-primary"
                                            @click="selectedOTA = [...new Set(selectedOTA.concat($refs['selectedOTA'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                                            class="text-primary" @click="selectedOTA = []">{{ $t('UN_SELECT_ALL') }}</a>
                                        </p>
                                    </template>

                                    <template v-slot:selection="{ item, index }">
                                        <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                                            @click:close="remove(index, selectedOTA)" @click="item.select">
                                            <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                                        </v-chip>
                                        <span v-if="index === 1" class="grey--text caption">(+{{ selectedOTA.length - 1 }})</span>
                                    </template>
                                    <template slot="no-data">
                                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                                    </template>
                                </v-autocomplete>
                            </b-col>

                            <b-col md="6" class="pt-0">
                                <label>{{
                                    $t("_BOOKING.BOOKING_STATUS")
                                }}</label>
                                <v-autocomplete dense outlined item-text="text" item-value="value"
                                    :items="listBookingStatus" v-model="selectedBookingStatus" chips multiple  ref="selectedBookingStatus">
                                    <template v-slot:prepend-item>
                                        <p class="mx-3 mt-1"> <a class="text-primary"
                                            @click="selectedBookingStatus = [...new Set(selectedBookingStatus.concat($refs['selectedBookingStatus'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                                            class="text-primary" @click="selectedBookingStatus = []">{{ $t('UN_SELECT_ALL') }}</a>
                                        </p>
                                    </template>

                                    <template v-slot:selection="{ item, index }">
                                        <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                                            @click:close="remove(index, selectedBookingStatus)" @click="item.select">
                                            <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                                        </v-chip>
                                        <span v-if="index === 1" class="grey--text caption">(+{{ selectedBookingStatus.length - 1 }})</span>
                                    </template>
                                    <template slot="no-data">
                                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                                    </template>
                                </v-autocomplete>
                            </b-col>
                        </b-row>
                        <b-row >
                            <b-col :md="syncPMS ? '6' : '12'" class="pt-0" :class="syncPMS ? 'pr-0' : ''">
                                <label>{{
                                    $t("SEARCH_BY_BOOKER")
                                }}</label>
                                <v-text-field v-model="customerName" dense outlined></v-text-field>
                            </b-col>
                            <b-col md="6" v-if="syncPMS" class="pt-0">
                                <label>
                                    {{
                                        $t("_BOOKING.SEARCH_PMS_STATUS")
                                    }}
                                </label>
                                <v-autocomplete outlined dense item-text="text" item-value="value"
                                    :items="listSearchPmsStatus" v-model="selectedSearchPmsStatus" chips>
                                    <template v-slot:selection="{ item, index }">
                                        <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected">
                                            <span>{{ item.text }}</span>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </b-col>
                        </b-row>
                        <!-- End coding -->
                        <div class="d-flex justify-end align-items-end flex-wrap py-0 mb-2">
                            <div class="mr-3 reset">
                                <v-btn class="pl-5 pr-5" @click="reset()">
                                    <v-icon size="20" left>
                                        mdi-refresh
                                    </v-icon>
                                    {{ $t("_BOOKING.RESET") }}
                                </v-btn>
                            </div>
                            <div class="mr-3">
                                <v-btn color="primary" class="pl-5 pr-5" @click="getAll(true)">
                                    <v-icon size="20" left>
                                        search
                                    </v-icon>
                                    {{ $t("_BOOKING.SEARCH") }}
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <!-- end -->
                </div>

                <!-- button scroll -->
                <div ref="containerCondition" class="container-condition py-4 pt-0">
                    <div class="d-flex align-items-center">
                        <button
                                v-if="isShowArrow"
                                class="left round"
                                @click="scrollLeft"
                            >
                            <v-icon>mdi-chevron-left</v-icon>
                        </button>
                        <div ref="scrollContainer" class="overflow-auto scroll-container" id="debug-scroll">
                            <div v-if="conditionSearch === 'BOOKING_DATE'" class="d-inline-flex gap-3">
                                <label class="" :title="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                                    {{ this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE") }} {{ conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                                </div>
                                </label>
                            </div>

                            <div v-if="conditionSearch === 'CHECKIN_DATE'" class="d-inline-flex gap-3">
                                <label class="" :title="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                                        {{ this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE") }} {{ conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                                </div>
                                </label>
                            </div>

                            <div v-if="conditionSearch === 'CHECKOUT_DATE'" class="d-inline-flex gap-3">
                                <label class="" :title="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                                        {{ this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE") }} {{ conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                                </div>
                                </label>
                            </div>

                            <div v-if="conditionSearch === 'STAY_DATE'" class="d-inline-flex gap-3">
                                <label class="" :title="conditionStayDate ? formatDate(conditionSearch, conditionStayDate) : ''">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear ? 'active-condition' : ''">
                                    {{ this.$t("_BOOKING.SEARCH_BY.STAYING_DATE") }} {{ conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear ? ': '+ formatDate(conditionSearch, conditionStayDate) : ''  }}
                                </div>
                                </label>
                            </div>

                            <div v-if="listNameOTA && listNameOTA.length > 0" class="d-inline-flex gap-3">
                                <label :title="listNameOTA.join('\n')">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameOTA.length > 0 && !isClear ? 'active-condition' : ''">
                                    {{ $t("BOOKING_CHANNEL") }} {{ listNameOTA.length > 0 && !isClear ? (listNameOTA.length > 1 ? ': ' + listNameOTA[0]+'...' : ': ' + listNameOTA[0]) : ''  }}
                                </div>		
                                </label>
                            </div>

                            <div v-if="listNameBKStatus && listNameBKStatus.length > 0" class="d-inline-flex gap-3">
                                <label :title="listNameBKStatus.join('\n')">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameBKStatus.length > 0 && !isClear ? 'active-condition' : ''">
                                    {{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }} {{ listNameBKStatus.length > 0 && !isClear ? (listNameBKStatus.length > 1 ? ': ' + listNameBKStatus[0]+'...' : ': ' + listNameBKStatus[0]) : ''  }}
                                </div>		
                                </label>
                            </div>

                            <div v-if="conditionCustomerName" class="d-inline-flex gap-3">
                                <label :title="conditionCustomerName">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCustomerName && !isClear ? 'active-condition' : ''">
                                    {{  $t("SEARCH_BY_BOOKER") }} {{ conditionCustomerName && !isClear ? ': ' + conditionCustomerName : '' }}
                                </div>		
                                </label>
                            </div>

                            <div v-if="syncPMS && listNamePmsStt && listNamePmsStt.text" class="d-inline-flex gap-3">
                                <label :title="listNamePmsStt.text">
                                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="!isClear ? 'active-condition' : ''">
                                    {{ $t("_BOOKING.SEARCH_PMS_STATUS") }} {{ !isClear ? ': ' + listNamePmsStt.text : '' }}
                                </div>		
                                </label>
                            </div>                            
                        </div>
                        <button
                            v-if="isShowArrow"
                            class="right round"
                            @click="scrollRight"
                        >
                            <v-icon>mdi-chevron-right</v-icon>
                        </button>
                    </div>
                </div>
                <!-- button scroll -->

                <v-progress-linear class="custom-progress" color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>

                <v-simple-table v-if="!isLoading" class="table-booking">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th v-for="header in headers" :class="header.class">
                                    {{ header.text }}
                                    <template v-if="['priceBeforeCommission', 'priceAfterCommission'].includes(header.value)">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" class="fs-14">mdi-information</v-icon>
                                            </template>
                                            <div class="fs-13" style="max-width: 300px">{{ $t('COMMISSION_RATE_NOTE') }}</div>
                                        </v-tooltip>
                                    </template>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="dataTable.length > 0">
                                <tr v-for="(item, i) in dataTable">
                                    <td class="text-center vertical-middle">{{ paging.offset + i + 1 }}</td>
                                    <td class="vertical-middle font-weight-bold">
                                        <a class="app-link text-decoration-none" href="javascript:;"
                                            @click="goToBookingDetail(item.bookingCode)">
                                            {{
                                                item.bookingCustomer.name + ' ' + item.bookingCustomer.surname
                                            }}
                                        </a>
                                    </td>
                                    <td class="vertical-middle">{{ item.otaBookingCode }}</td>
                                    <td class="text-center vertical-middle">
                                        <template v-if="item.arrival && item.departure">
                                        {{
                                            _formatDateTime(
                                            item.arrival,
                                            "YYYY-MM-DD",
                                            systemLang == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
                                            ) +
                                            " - " +
                                            _formatDateTime(
                                            item.departure,
                                            "YYYY-MM-DD",
                                            systemLang == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
                                            )
                                        }}
                                        </template>
                                        <template v-else>N/A</template>
                                    </td>
                                    <td class="text-right vertical-middle font-weight-bold">
                                        {{ formatCurrency(item.amount, item.currencyCode) }}
                                    </td>
                                    <td class="text-center vertical-middle"
                                        :style="{ color: listBookingStatus.find(x => x.value == item.bookingStatus).color }">
                                        {{
                                            listBookingStatus.find(x => x.value == item.bookingStatus).text
                                        }}
                                    </td>
                                    <td class="text-center vertical-middle">
                                        {{
                                            item.bookingCode
                                        }}
                                    </td>
                                    <td class="text-center vertical-middle">
                                        {{ item.ota.otaI18n.find(x => x.lang == defaultI18n).name }}
                                    </td>
                                    <td class="text-center vertical-middle">
                                        {{ utcConvertToLocalTimeZone(item.createdDate) }}
                                    </td>
                                    <td class="text-center vertical-middle">
                                        {{ item.paymentCollectType === 0 ? 'Property collect' : item.paymentCollectType === 1 ? 'OTA contact' : 'Channel collect' }}
                                    </td>
                                    <td class="text-right vertical-middle font-weight-bold">
                                        <strong>{{item.priceBeforeCommission ? formatCurrency(item.priceBeforeCommission, item.currencyCode) : 'N/A' }}</strong>
                                    </td>
                                    <td class="text-right vertical-middle font-weight-bold">
                                        <strong>{{ item.commission ? formatCurrency(item.commission, item.currencyCode) : 'N/A' }}</strong>
                                    </td>
                                    <td class="text-right vertical-middle font-weight-bold">
                                        <strong>{{item.priceAfterCommission ? formatCurrency(item.priceAfterCommission, item.currencyCode) : 'N/A'}}</strong>
                                    </td>
                                    <td class="text-center vertical-middle" :class="syncPMS ? '' : 'd-none'">
                                        <template>
                                            <v-menu bottom left>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn depressed :color="item.channelStatus === 1 ? 'success' : ''"
                                                        x-small v-bind="attrs" v-on="on" class="rounded-sm  mr-1" outlined>
                                                        <i class="icon-more_vert fs-16 cursor font-weight-bold"></i>
                                                    </v-btn>
                                                </template>

                                                <div class="d-flex bg-white p-2">
                                                    <div class="mr-3">
                                                        <p v-if="item.channelStatus === 1" class="m-0 pr-3">
                                                            <span class="text-success">{{
                                                                $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED') }}</span>
                                                            <br>
                                                            <span class="fs-10">{{
                                                                utcConvertToLocalTimeZone(item.channelTime)
                                                            }}</span>
                                                        </p>
                                                        <p v-else class="m-0 pr-3">{{
                                                            $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED') }}</p>
                                                    </div>
                                                    <div class="text-right">
                                                        <p class="mb-0">{{ item.pmsCode.split(',').map(e => $t(e)).join(",")
                                                        }}</p>
                                                        <v-btn color="success" v-if="fnReSync" x-small
                                                            @click.stop="openPopupReSync(item)"><small>{{ $t('RE_SYNC')
                                                            }}</small></v-btn>
                                                    </div>
                                                </div>
                                            </v-menu>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td :colspan="headers.length" class="text-center vertical-middle font-weight-bold font-italic"
                                        style="color:red">
                                        {{ $t('BOOKING_EMPTY') }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-row
                    class="mt-2 mx-3"
                    align="center"
                    justify="center"
                    >
                    <span class="grey--text">{{  $t('ITEMS_PER_PAGE') }}</span>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            dark
                            text
                            color="primary"
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            {{ paging.limit }}
                            <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                        </template>
                        <v-list>
                        <v-list-item
                            v-for="(number, index) in itemsPerPageArray"
                            :key="index"
                            @click="paging.limit = number; getAll(true)"
                        >
                            <v-list-item-title>{{ number }}</v-list-item-title>
                        </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-spacer></v-spacer>
                    <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage" class="pl-3 pr-3">
                        <span slot="totalItems">{{ $t("TOTAL") }}: {{ $tc("_BOOKING.BOOKING", paging.total) }}</span>
                    </paging>
                </v-row>
            </div>
        </div>
        <confirm-dialog @deleteItem="reSync" :maxWidth="325" :persistent="true" ref="reSyncDialogComponent">
            <span slot="title">{{ $t("CONFIRM_RE_SYNC") }} booking: {{ bookingReSync ? bookingReSync.otaBookingCode :
                null }}</span>
        </confirm-dialog>
        <v-navigation-drawer
            v-model="showDetail"
            absolute
            temporary
            right
            width="1000"
        >
            <booking-detail-unmap 
                v-if="showDetail" 
                :code="code" 
                @close="()=> {showDetail = false}"
            ></booking-detail-unmap>
        </v-navigation-drawer>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import Paging from "@/components/Utils/Paging.vue";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import {
    _alert,
    _formatCurrency,
    _formatDateTimeUTCToLocal
} from "@/_helpers/function.js";
import { service } from "@/_services/Booking/booking.service.js";
import moment from "moment";
import FileSaver from "file-saver";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import BookingDetailUnmap from './BookingDetailUnmap.vue';
export default {
    components: {
        DateRangePicker,
        paging: Paging,
        "date-picker": DatePicker,
        "confirm-dialog": ConfirmDialog,
        BookingDetailUnmap,
    },
    data() {
        return {
            locale_data: {
                format: 'YYYY-MM-DD',
                separator: ' - ',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                weekLabel: 'W',
                daysOfWeek: [this.$t("_DATE_RANGE.SUNDAY"), this.$t("_DATE_RANGE.MONDAY"), this.$t("_DATE_RANGE.TUESDAY"), this.$t("_DATE_RANGE.WEDNESDAY"), this.$t("_DATE_RANGE.THURSDAY"), this.$t("_DATE_RANGE.FRIDAY"), this.$t("_DATE_RANGE.SATURDAY")],
                monthNames: [this.$t("_DATE_RANGE.JAN"), this.$t("_DATE_RANGE.FEB"), this.$t("_DATE_RANGE.MAR"), this.$t("_DATE_RANGE.APR"), this.$t("_DATE_RANGE.MAY"), this.$t("_DATE_RANGE.JUN"), this.$t("_DATE_RANGE.JUL"), this.$t("_DATE_RANGE.AUG"), this.$t("_DATE_RANGE.SEP"), this.$t("_DATE_RANGE.OTC"), this.$t("_DATE_RANGE.NOV"), this.$t("_DATE_RANGE.DEC")],
                firstDay: 1
            },
            dateRange: [],
            stayDate: null,
            systemLang: this.$i18n.locale,
            isLoading: false,
            dataTable: [],
            selectedSearchCondition: 'BOOKING_DATE',
            listSearchCondition: [
                {
                    value: "BOOKING_CODE",
                    text: this.$t("_BOOKING.SEARCH_BY.BOOKING_CODE")
                },
                {
                    value: "BOOKING_CODE_OTA",
                    text: this.$t("BOOKING_CODE_OTA")
                },
                {
                    value: "BOOKING_DATE",
                    text: this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE")
                },
                {
                    value: "CHECKIN_DATE",
                    text: this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE")
                },
                {
                    value: "CHECKOUT_DATE",
                    text: this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE")
                },
                {
                    value: "STAY_DATE",
                    text: this.$t("_BOOKING.SEARCH_BY.STAYING_DATE")
                }
            ],
            selectedBookingStatus: [0, 1, 2, 3, 4, 5, 6, 7],
            listBookingStatus: [
                {
                    value: 0,
                    text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
                    color: "rgb(254, 209, 47)",
                    bg: "rgba(253, 185, 19, 0.12)",
                    colorText: 'text-white'
                },
                {
                    value: 1,
                    text: this.$t("_BOOKING.STATUS.CONFIRM"),
                    color: "#0da313",
                    colorText: 'text-white'
                },
                {
                    value: 2,
                    text: this.$t("_BOOKING.STATUS.CANCEL"),
                    color: "#808080",
                    bg: "rgba(128, 128, 128, 0.12)",
                    colorText: 'text-white'
                },
                {
                    value: 3,
                    text: this.$t("_BOOKING.STATUS.VOID"),
                    color: "#262626",
                    bg: "rgba(38, 38, 38, 0.12)",
                    colorText: 'text-white'
                },
                {
                    value: 4,
                    text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
                    color: "#262626",
                    bg: "rgba(38, 38, 38, 0.12)",
                    colorText: 'text-white'
                },
                {
                    value: 5,
                    text: this.$t("_BOOKING.STATUS.CLOSE"),
                    color: "#262626",
                    bg: "rgba(38, 38, 38, 0.12)",
                    colorText: 'text-white'
                },
                {
                    value: 6,
                    text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
                    color: "#ff0000",
                    bg: "rgba(255, 0, 0, 0.12)",
                    colorText: 'text-white'
                },
                {
                    value: 7,
                    text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
                    color: "#fed12f",
                    bg: "rgba(254, 209, 47, 0.12)",
                    colorText: 'text-white'
                },
            ],
            listSelectOTA: [],
            selectedOTA: [],
            paging: {
                total: 0,
                limit: 15,
                offset: 0,
                searchBy: 'BOOKING_DATE',
                otaId: []
            },
            pagingMobile: {
                total: 0,
                limit: 15,
                code: null,
                offset: 0,
                searchBy: 'BOOKING_DATE',
                otaId: [],
                status: [],
            },
            customerName: null,
            bookingList: [],
            index: 0,
            loadingView: true,
            end: true,
            syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
            fnReSync: false,
            bookingReSync: null,
            listSearchPmsStatus: [
                {
                    value: null,
                    text: this.$t("ALL")
                },
                {
                    value: 1,
                    text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED")
                },
                {
                    value: 0,
                    text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED")
                },
            ],
            listSearchPmsCode: [
                {
                    value: null,
                    text: this.$t("ALL")
                },
                {
                    value: 'ez_FOLIO',
                    text: this.$t("ez_FOLIO")
                },
                {
                    value: 'ez_CLOUDHOTEL',
                    text: this.$t("ez_CLOUDHOTEL")
                },
                {
                    value: '',
                    text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.UNSYNCHRONIZED")
                },
            ],
            selectedSearchPmsStatus: null,
            selectedSearchPmsCode: null,
            showDetail: false,
            code: null,
            currentRoute: this.$route.path,
            isShowPopup: false,
            isScrollLeftDisabled: true,
            isScrollRightDisabled: false,
            conditionStayDate: null,
            bookingCodeSearch: '',
            isClear: false,
            listNameBKStatus: [],
            listNamePmsStt: [],
            conditionDateRange: [],
            conditionSearch: 'BOOKING_DATE',
            widthScroll: 0,
            widthContainer: 0,
            resizeObserver: null,
            isShowArrow: false
        };
    },
    watch: {
        showDetail() {
            if(this.showDetail == false) {
                history.pushState(null, '', `${this.currentRoute}`);
            }
        },
        selectedBookingStatus() {
            this.paging.status = this.selectedBookingStatus.length == 0 ? null : this.selectedBookingStatus;
        },
        selectedSearchCondition() {
            this.paging.searchBy = this.selectedSearchCondition;
            this.pagingMobile.searchBy = this.selectedSearchCondition;
        },
        selectedOTA() {
            this.paging.otaId = this.selectedOTA;
        },
        dateRange() {
            this.paging.from = this.dateRange[0];
            this.paging.to = this.dateRange[1];
            this.pagingMobile.from = this.dateRange[0];
            this.pagingMobile.to = this.dateRange[1];
        },
        widthScroll() {
            if (this.widthScroll + 50 > this.widthContainer) {
                this.isShowArrow = true;
            } else {
                this.isShowArrow = false;
            }
        }
    },
    created() {
        let searchHistoryListBookingUnmap = sessionStorage.getItem('searchHistoryListBookingUnmap');
        if (searchHistoryListBookingUnmap) {
            searchHistoryListBookingUnmap = JSON.parse(searchHistoryListBookingUnmap);
            this.selectedSearchCondition = searchHistoryListBookingUnmap.selectedSearchCondition;
            this.paging = searchHistoryListBookingUnmap.paging;
            this.dateRange = [
                new Date(searchHistoryListBookingUnmap.dateRange[0]),
                new Date(searchHistoryListBookingUnmap.dateRange[1])
            ];
            this.stayDate = new Date(searchHistoryListBookingUnmap.stayDate);
            this.selectedOTA = searchHistoryListBookingUnmap.selectedOTA;
            this.selectedBookingStatus = searchHistoryListBookingUnmap.selectedBookingStatus;
            if (searchHistoryListBookingUnmap.selectedBookingStatus.length == 0) {
                this.paging.status = null;
            }
            this.customerName = searchHistoryListBookingUnmap.customerName;
            this.selectedSearchPmsStatus = searchHistoryListBookingUnmap.selectedSearchPmsStatus;
        } else {
            const today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            const day1 = new Date(moment().add(1, 'day'));
            day1.setHours(0);
            day1.setMinutes(0);
            day1.setSeconds(0);
            this.dateRange = [today,
            day1
            ];
            this.stayDate = new Date(moment().format('YYYY-MM-DD'));
        }
    },
    mounted() {
        this.initialize();
    },
    beforeDestroy() {
      if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      }
    },
    computed: {
        numberSearch() {
            var num = 0
            if (this.customerName) {
                num += 1;
            }
            if (this.selectedSearchPmsStatus !== null) {
                num += 1;
            }
            return num
        },
        numberFilter() {
            var num = 0;
            switch (this.selectedSearchCondition) {
                case 'BOOKING_CODE':
                    if (this.pagingMobile.code) {
                        num += 1
                    }
                    break;

                case 'BOOKING_CODE_OTA':
                    if (this.pagingMobile.code) {
                        num += 1
                    }
                    break;

                case 'BOOKING_DATE':
                    num += 1
                    break;

                case 'CHECKIN_DATE':
                    num += 1
                    break;

                case 'CHECKOUT_DATE':
                    num += 1
                    break;
                default:
                    break;
            }
            if (this.pagingMobile.status.length > 0) {
                num += 1;
            }
            if (this.pagingMobile.otaId.length > 0) {
                num += 1;
            }
            return num;
        },
        headers() {
            return [
                {
                    text: this.$t("STT"),
                    class: "text-center"
                },
                {
                    text: this.$t("BOOKING_CUSTOMER_NAME"),
                    value: "name",
                },
                {
                    text: this.$t("BOOKING_CODE_OTA"),
                    value: "otaBookingCode",
                },
                {
                    text: this.$t("_BOOKING.TIME_STAY"),
                    value: "timeStay",
                    class: "text-center"
                },
                {
                    text: this.$t("_BOOKING.AMOUNT"),
                    value: "totalAmount",
                    class: "text-right"
                },
                {
                    text: this.$t("_BOOKING.BOOKING_STATUS"),
                    class: "text-center",
                    value: "status",
                },
                {
                    text: this.$t("_BOOKING.BOOKING_CODE"),
                    class: "text-center",
                    value: "bookingCode",
                },
                {
                    text: this.$t("BOOKING_CHANNEL"),
                    class: "text-center",
                    value: "bookingChannel",
                },
                {
                    text: this.$t("_BOOKING.BOOKING_DATE"),
                    value: "bookingDate",
                    class: "text-center"
                },
                {
                    text: 'Payment collect',
                    value: "paymentCollectType",
                    class: "text-center"
                },
                {
                    text: this.$t('_BOOKING_DETAIL.BEFORE_COMMISSION'),
                    value: "priceBeforeCommission",
                    class: "text-right",
                },
                {
                    text: this.$t('_BOOKING_DETAIL.COMMISSION'),
                    value: "commission",
                    class: "text-right",
                },
                {
                    text: this.$t('_BOOKING_DETAIL.AFTER_COMMISSION'),
                    value: "priceAfterCommission",
                    class: "text-right",
                },
                {
                    text: this.$t("_DASHBOARD.SYNC_PMS"),
                    value: "syncPms",
                    class: this.syncPMS ? "text-center" : 'd-none'
                },
            ];
        }
    },
    methods: {
        openPopupReSync(item) {
            this.bookingReSync = item
            this.$refs.reSyncDialogComponent.open(item)
        },
        reSync(item) {
            const body = {
                bookingCode: item.bookingCode
            };
            service.reSyncUnmap(body).then(res => {
                _alert(res, this.$t(res.data), false);
            });
        },
        removeFilter() {
            this.selectedSearchCondition = 'BOOKING_CODE',
                this.pagingMobile.code = null;
            this.pagingMobile.status = [];
            this.pagingMobile.otaId = [];
        },
        openSearch() {
            document.getElementById('overlay').style.display = 'block';
            document.getElementById('overlay').style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
            document.getElementById('my-search').style.top = 0;
        },
        closeNav() {
            if (document.getElementById('my-search').offsetTop === 0) {
                this.searchBooking(true);
            }
            document.getElementById('overlay').style.display = 'none';
            document.getElementById('my-search').style.top = '-130vh';
        },
        _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
            if (!value) {
                return "";
            }
            return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
            // return moment(value).format(outputFormat);
        },
        _formatDateTime(value, inputFormat, outputFormat) {
            if (!value) {
                return "";
            }
            return moment(value).format(outputFormat);
        },
        calcTotalAmount(bookingLines) {
            let amount = 0;
            bookingLines.forEach(x => {
                amount = amount + x.amountPax;
            });
            return _formatCurrency(amount);
        },
        formatCurrency: _formatCurrency,
        async initialize() {
            const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
            const userRole = currentUser.user.roles
                ? currentUser.user.roles.map(role => role.fnCode)
                : undefined;
            this.fnReSync = userRole.indexOf("HOTEL_BOOKING_UNMAP_REPOST") >= 0
            let body = {
                keyword: "",
                status: 1
            };
            await syncota.getAllOTA(body).then(res => {
                if (res.responseCode === 0) {
                    res.data.forEach(x => {
                        this.listSelectOTA.push({
                            value: x.id,
                            text: x.otaI18n.find(y => y.lang == this.defaultI18n).name
                        });
                        this.selectedOTA = this.listSelectOTA.map(e => e.value)
                    });
                    this.listSelectOTA.sort((a, b) => a.text.localeCompare(b.text));
                } else {
                    _alert(res, this.$t(res.data), false);
                }
            });
            this.getAll();
        },
        // Change page
        changePage(paging) {
            this.paging = paging;
            this.getAll();
        },
        // Reset
        reset() {
            this.selectedSearchCondition = 'BOOKING_DATE';
            const today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            const day1 = new Date(moment().add(1, 'day'));
            day1.setHours(0);
            day1.setMinutes(0);
            day1.setSeconds(0);
            this.dateRange = [today,day1];
            this.selectedOTA = this.listSelectOTA.map(e => e.value);
            this.selectedBookingStatus = this.listBookingStatus.map(e => e.value);
            this.customerName = null;
        },
        // Get all booking
        getAll(isSearching) {
            this.bookingCodeSearch = '';
            this.mapValuesOTA();
            this.mapValuesBKStatus();
            this.mapValuesPmsStt();
            this.conditionStayDate = this.stayDate;
            this.conditionCustomerName = this.customerName;
            this.conditionDateRange = this.deepCopyArrayWithDates(this.dateRange);
            this.conditionSearch = this.selectedSearchCondition;
            this.isShowPopup = false;
            this.paging.searchBy = this.selectedSearchCondition;
            this.isClear = false;
            if (this.paging.searchBy === null || this.paging.searchBy === 'BOOKING_DATE' || this.paging.searchBy === 'CHECKIN_DATE' || this.paging.searchBy === 'CHECKOUT_DATE') {
                if (this.isSixMonthsOrLess(this.paging.from, this.paging.to) === 1) {
                _alert(null, this.$t("PLEASE_SELECT_DATE_LESS_6_MONTH"));
                return
                }
            }
            if ((this.paging.searchBy === 'BOOKING_CODE_OTA' || this.paging.searchBy === 'BOOKING_CODE') && !this.paging.code) {
                this.paging.total = 0;
                this.dataTable = [];
                return
            }
            if (isSearching) this.paging.offset = 0;
            this.isLoading = true;
            const body = {
                limit: this.paging.limit,
                offset: this.paging.offset,
                lang: this.paging.lang,
                searchBy: this.paging.searchBy,
                from: this.paging.from,
                to: this.paging.to,
                code: this.paging.code,
                status: this.paging.status,
                otaIds: this.paging.otaId,
                customerName: this.customerName,
                channelStatus: this.selectedSearchPmsStatus,
                pmsCode: this.selectedSearchPmsCode,
                stayDate: moment(this.stayDate).format('YYYY-MM-DD')
            };
            service
                .getAllBookingUnmap(body)
                .then(res => {
                    if (res.responseCode === 0) {
                        this.paging.total = res.total;
                        this.dataTable = res.data;
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.isLoading = false));
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.target === this.$refs.scrollContainer) {
                    this.widthScroll = entry.contentRect.width;
                    } else if (entry.target === this.$refs.containerCondition) {
                    this.widthContainer = entry.contentRect.width;
                    }
                }
            });
            this.resizeObserver.observe(this.$refs.scrollContainer);
            this.resizeObserver.observe(this.$refs.containerCondition);
        },
        searchByCode() {
            this.dateRange = [];
            this.listNameOTA = []
            this.listNameBKStatus = [];
            this.listNamePmsStt = null;
            this.customerName = null;
            this.isClear = true;
            this.paging.searchBy = 'BOOKING_CODE_OTA';
            if (this.paging.searchBy === 'BOOKING_CODE_OTA' && !this.bookingCodeSearch) {
                this.paging.total = 0;
                this.dataTable = [];
                return
            }
            this.isLoading = true;
            const body = {
                limit: this.paging.limit,
                offset: this.paging.offset,
                lang: this.paging.lang,
                searchBy: this.paging.searchBy,
                from: this.paging.from,
                to: this.paging.to,
                code: this.bookingCodeSearch,
                status: [],
                otaIds: [],
                customerName: null,
                channelStatus: null,
                pmsCode: null,
                stayDate: null
            };
            service
                .getAllBookingUnmap(body)
                .then(res => {
                    if (res.responseCode === 0) {
                        this.paging.total = res.total;
                        this.dataTable = res.data;
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        remove(index, array) {
            array.splice(index, 1);
            this.$forceUpdate();
        },
        // Go to booking detail page
        goToBookingDetail(code) {
            this.code = code;
            let searchHistoryListBookingUnmap = {
                selectedSearchCondition: this.selectedSearchCondition,
                paging: this.paging,
                dateRange: this.dateRange,
                stayDate: this.stayDate,
                selectedOTA: this.selectedOTA,
                selectedBookingStatus: this.selectedBookingStatus,
                customerName: this.customerName,
                selectedSearchPmsStatus: this.selectedSearchPmsStatus
            };
            sessionStorage.setItem('searchHistoryListBookingUnmap', JSON.stringify(searchHistoryListBookingUnmap));
            const routeInfo = this.$router.resolve({ 
            name: "bookingDetailUnmap",
            params: { code: code } 
            });
            history.pushState(null, '', routeInfo.href);
            this.showDetail = true;
        },
        // Export booking
        exportBooking() {
            this.isLoading = true;
            let param = {
                searchBy: this.paging.searchBy,
                from: this.paging.from,
                to: this.paging.to,
                code: this.paging.code,
                agentName: this.paging.agentName,
                status: this.paging.status,
                lang: this.defaultI18n,
                customerName: this.customerName,
                otaIds: this.paging.otaId,
                exportDate: moment(new Date()).format('YYYY-MM-DD_HH:mm:ss'),
                channelStatus: this.selectedSearchPmsStatus,
                pmsCode: this.selectedSearchPmsCode,
                stayDate: moment(this.stayDate).format('YYYY-MM-DD')
            };
            service
                .exportBookingUnmap(param)
                .then(res => {
                    if (res.responseCode === 0) {
                        const url = res.data;
                        FileSaver.saveAs(url);
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        // mobile
        viewMore() {
            this.loadingView = true;
            if (this.end === false) {
                this.index++;
            }
            this.searchBooking();
        },
        lazyLoad() {
            const list = document.getElementById('list-booking-scroll');
            if (list && list.offsetHeight &&
                window.pageYOffset >= list.offsetHeight - 800 &&
                this.loadingView === false &&
                this.end === false
            ) {
                this.viewMore();
            }
        },
        searchBooking(val) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                const body = {
                    limit: 20,
                    offset: this.index * 20,
                    lang: this.pagingMobile.lang,
                    searchBy: this.pagingMobile.searchBy,
                    from: this.pagingMobile.from,
                    to: this.pagingMobile.to,
                    code: this.pagingMobile.code,
                    status: this.pagingMobile.status,
                    otaIds: this.pagingMobile.otaId,
                    customerName: this.customerName,
                    stayDate: moment(this.stayDate).format('YYYY-MM-DD')
                };
                if (this.index === 0 || val) {
                    this.isLoading = true;
                    this.index = 0;
                    this.bookingList = [];
                }
                this.loadingView = true;
                this.end = true;
                this.$session.set("ojbBookingMobile", this.pagingMobile);
                service
                    .getAllBookingMobile(body)
                    .then(res => {
                        if (res.responseCode === 0) {
                            this.pagingMobile.total = res.total;
                            res.data.forEach(element => {
                                this.bookingList.push(element);
                            });
                            this.bookingList = Array.from(new Set(this.bookingList));
                            if (res.data.length < 20) {
                                this.end = true;
                            } else {
                                this.end = false;
                            }
                            setTimeout(() => {
                                if (this.index === 0) {
                                    document.body.scrollTop = 0; // For Safari
                                    document.documentElement.scrollTop = 0;
                                    window.addEventListener('scroll', this.lazyLoad);
                                }
                                this.loadingView = false;
                            }, 300);
                        } else {
                            _alert(res, this.$t(res.data), false);
                        }
                        document.getElementById('overlay').style.display = 'none';
                        document.getElementById('my-search').style.top = '-130vh';
                        this.isLoading = false;
                    })
                    .finally(() => (this.loadingView = false));
            }, 500);

        },
        openPopup() {
            this.isShowPopup = !this.isShowPopup;
        },
        scrollLeft() {
            const container = this.$refs.scrollContainer;
            container.scrollBy({
                left: -200,
                behavior: "smooth",
            });
        },
        scrollRight() {
            const container = this.$refs.scrollContainer;
            container.scrollBy({
                left: 200,
                behavior: "smooth",
            });
        },
        
        formatDate(condition, dateRage) {            
            var dateStart = moment(dateRage[0], "YYYY-MM-DD");
            var dateEnd = moment(dateRage[1], "YYYY-MM-DD");
            if (condition === 'BOOKING_DATE') {
                return dateStart.format("DD/MM/YYYY HH:mm:ss") + ' ~ ' + dateEnd.format("DD/MM/YYYY HH:mm:ss");
            } else if (condition === 'STAY_DATE') {                
                return moment(dateRage, "DD/MM/YYYY").format("DD/MM/YYYY");
            } else {
                return dateStart.format("DD/MM/YYYY")+ ' ~ ' + dateEnd.format("DD/MM/YYYY");
            }
        },
        mapValuesOTA() { 
            this.listNameOTA = this.selectedOTA.map(id => {
                const matchedItem = this.listSelectOTA.find(item => item.value === id); 
                return matchedItem ? matchedItem.text : null; 
            }).filter(item => item !== null)
        },
        mapValuesBKStatus() { 
            this.listNameBKStatus = this.selectedBookingStatus.map(id => {
                const matchedItem = this.listBookingStatus.find(item => item.value === id); 
                return matchedItem ? matchedItem.text : null; 
            }).filter(item => item !== null)
        },
        mapValuesPmsStt() {
            this.listNamePmsStt = this.listSearchPmsStatus.find(item => item.value === this.selectedSearchPmsStatus); 
        },
        _moment: moment
    }
};
</script>
